import { FunctionComponent, ReactElement, useState } from "react";
import styled from "styled-components";
import { colors } from "../../../styles/figmaColors";
import { Section } from "./Section";
import { Spacer } from "../Spacer";
import { TextCapitalized } from "../text/TextCapitalized";
import {
  ExpandMoreIconOutlined,
  ExpandLessIconOutlined,
} from "../../../designSystem/materialUi/materialUi";

type SidePanelExpandableProps = {
  title: string;
  header?: ReactElement<typeof Section>;
  children?:
    | ReactElement<typeof Section>
    | Iterable<ReactElement<typeof Section>>;
};

export const SidePanelExpandableDS: FunctionComponent<
  SidePanelExpandableProps
> = (props) => {
  const [isContentvisible, setIsContentvisible] = useState<boolean>(false);

  return (
    <StyledContainer>
      <Spacer x={0.5} />
      <StyledColumn>
        <Spacer y={1.5} />
        <StyledContent>
          <Spacer y={1} />
          <StyledHeader>
            <Spacer x={1} />
            <StyledExpandIcon
              onClick={() => setIsContentvisible(!isContentvisible)}
            >
              {isContentvisible ? (
                <ExpandLessIconOutlined />
              ) : (
                <ExpandMoreIconOutlined />
              )}
            </StyledExpandIcon>
            <StyledTextContainer>
              <TextCapitalized>{props.title}</TextCapitalized>
            </StyledTextContainer>
            <Spacer x={1} />
          </StyledHeader>
          <Spacer y={1} />
          {isContentvisible && (
            <StyledContentVisible>
              {props.header}
              <StyledOverflow>{props.children}</StyledOverflow>
              <Spacer y={1} />
            </StyledContentVisible>
          )}
        </StyledContent>
        <Spacer y={0.5} />
      </StyledColumn>
      <Spacer x={0.5} />
    </StyledContainer>
  );
};

const StyledContentVisible = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const StyledContainer = styled.div`
  z-index: 100;
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  font-size: 0.875rem;
  width: 100%;
`;

const StyledContent = styled.div`
  border-radius: 0.5rem;
  background-color: white;
  box-shadow:
    0px 0px 15px rgba(143, 143, 143, 0.15),
    0px 2px 5px rgba(143, 143, 143, 0.15);
  border: solid 1px ${colors["colors/borders/cells/cells"]};
`;

const StyledOverflow = styled.div`
  display: flex;
  max-height: 50vh;
  overflow: auto;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;
  height: 0%;
  pointer-events: auto;
`;

const StyledExpandIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.5rem;
  cursor: pointer;
  &:hover {
    background-color: ${colors["colors/surfaces/background/background_level1"]};
  }
`;

const StyledHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const StyledTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
